import api from '@/api';

const resource = 'ei/detalharatividade';

export default {
  deleteDetalharAtividade(data) {
    return api.delete(`${resource}/${data.identificadordetalharatividade}`);
  },
  postDetalharAtividade(data) {
    return api.post(`${resource}`, data);
  },
  putDetalharAtividade(data) {
    return api.put(`${resource}/${data.identificadordetalharatividade}`, data);
  },
  getDetalharAtividade(data){
    return api.get(`${resource}`,{
        params: data,
    })
  },
  getMaxValueDetalharAtividade(data){
    return api.get(`${resource}/disponivel`,{
        params: data,
    })
  }
};